import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-public-footer',
    standalone: true,
    imports: [RouterModule],
    template: `
        <footer class="bg-surface-900 dark:bg-surface-950 text-surface-0 py-12 px-6 sm:px-12 lg:px-20">
            <div class="max-w-7xl mx-auto">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
                    <!-- Company Info -->
                    <div class="col-span-1">
                        <div class="flex items-center gap-3 mb-4">
                            <img src="/images/apex/apex-logo.png" alt="Modern Apex" class="h-10 w-auto" />
                            <span class="text-xl font-bold">Modern Apex</span>
                        </div>
                        <p class="text-surface-400 text-sm leading-relaxed">
                            Modern Apex is committed to providing the highest quality facility maintenance services while considering our impact on the environment and communities we serve.
                        </p>
                    </div>

                    <!-- Quick Links -->
                    <div class="col-span-1">
                        <h4 class="text-lg font-semibold mb-4">Quick Links</h4>
                        <ul class="space-y-2 m-0 p-0 list-none">
                            <li>
                                <a [routerLink]="['/']" class="text-surface-400 hover:text-surface-0 transition-colors">Home</a>
                            </li>
                            <li>
                                <a [routerLink]="['/services']" class="text-surface-400 hover:text-surface-0 transition-colors">Services</a>
                            </li>
                            <li>
                                <a [routerLink]="['/contact']" class="text-surface-400 hover:text-surface-0 transition-colors">Contact Us</a>
                            </li>
                            <li>
                                <a [routerLink]="['/login']" class="text-surface-400 hover:text-surface-0 transition-colors">Client Login</a>
                            </li>
                        </ul>
                    </div>

                    <!-- Contact Info -->
                    <div class="col-span-1">
                        <h4 class="text-lg font-semibold mb-4">Contact Us</h4>
                        <ul class="space-y-3 m-0 p-0 list-none text-surface-400">
                            <li class="flex items-start gap-3">
                                <i class="pi pi-user mt-1"></i>
                                <span>Josse Lopez</span>
                            </li>
                            <li class="flex items-start gap-3">
                                <i class="pi pi-phone mt-1"></i>
                                <a href="tel:2133357066" class="hover:text-surface-0 transition-colors">213.335.7066</a>
                            </li>
                            <li class="flex items-start gap-3">
                                <i class="pi pi-map-marker mt-1"></i>
                                <span>
                                    303 S Union Ave., First Floor<br />
                                    Los Angeles, CA 90017
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Copyright -->
                <div class="border-t border-surface-700 mt-10 pt-6 text-center text-surface-500 text-sm">
                    <p>&copy; {{ currentYear }} Modern Apex Enterprises. All rights reserved.</p>
                </div>
            </div>
        </footer>
    `
})
export class PublicFooterComponent {
    currentYear = new Date().getFullYear();
}
